import { SearchSurgicalOrdersSchedules } from 'domain/usecases/surgical-order/search-surgical-orders-schedules'
import { SurgicalOrderRepository } from 'repository/interfaces/surgical-order-repository'

export class RemoteSearchSurgicalOrdersSchedules
  implements SearchSurgicalOrdersSchedules
{
  constructor(
    private readonly surgicalOrderRepository: SurgicalOrderRepository
  ) {}

  load(
    params: SearchSurgicalOrdersSchedules.Params
  ): Promise<SearchSurgicalOrdersSchedules.Model> {
    return this.surgicalOrderRepository.searchSurgicalOrdersSchedules(params)
  }
}

export type SearchSurgicalOrdersSchedulesModel =
  SearchSurgicalOrdersSchedules.Model
